import styled from '@emotion/styled';

import ReactMarkdown from 'react-markdown';
import { TransformOptions } from 'react-markdown/lib/react-markdown';

interface MarkdownProps {
  children: string;
  options?: TransformOptions;
  style?: React.CSSProperties;
  className?: string;
}

const MarkdownContainer = styled.div`
  white-space: pre-wrap;
  line-height: 1.5;
  ul {
    padding-left: 1.5em;
    margin: 0;
    margin-top: 0;
  }

  li {
    white-space: normal;
    margin-bottom: 0.3em;
    line-height: inherit;
  }

  a {
    transition: color 0.3s ease;
    text-decoration: underline;
  }

  a:hover {
    color: #ccc;
  }
`;

const Markdown = ({ children, options, className, style }: MarkdownProps) => {
  return (
    <MarkdownContainer className={className} style={style}>
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p {...props} />, // Default paragraph rendering
        }}
        linkTarget="_blank"
        {...options}
      >
        {children}
      </ReactMarkdown>
    </MarkdownContainer>
  );
};

export default Markdown;
